export default class ShootOptions {
  public numRounds: number;

  public constructor(
    numRounds: number = 1,
  ) {
    this.numRounds = numRounds;
  }
}
